import React from 'react';

const CardMapa = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: '20px 15px',
      boxSizing: 'border-box'
    }}>
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3937.402765284644!2d-75.38182292600095!3d9.297533884729818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e5915b1ace1de83%3A0x2f934a49a13031f5!2sCruz%20Roja%20Colombiana%20-%20Seccional%20Sucre!5e0!3m2!1ses!2sco!4v1787427620603!5m2!1ses!2sco" 
        style={{ 
          border: 0, 
          width: '100%',
          maxWidth: '1900px',
          height: '460px',
          maxHeight: '70vh', /* Ajusta la altura proporcionalmente en pantallas pequeñas */
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }} 
        allowFullScreen="" 
        loading="lazy" 
        referrerPolicy="no-referrer-when-downgrade"
        title="Ubicación Cruz Roja Colombiana - Seccional Sucre"
      />
    </div>
  );
};

export default CardMapa;
